
































































































































/// <reference lib="webworker" />

import Board from "./Board.vue";
import "@/styles/controls.scss";
import Vue from "vue";
import Component from "vue-class-component";
import { Watch } from "vue-property-decorator";

@Component<Controls>({
  created() {
    // @ts-expect-error ...
    document.addEventListener("swUpdated", this.updateAvailable, {
      once: true,
    });

    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (this.refreshing) return;
      this.refreshing = true;
      window.location.reload();
    });
  },

  computed: {
    finished() {
      return this.$parent.manager.state.finished;
    },
    difficultHint() {
      const difficult: Record<number, string> = {
        1: "passive",
        2: "passive",
        3: "easy",
        4: "easy",
        5: "moderate",
        6: "moderate",
        7: "tougher",
        8: "tougher",
      };
      return `AI ${
        this.$parent.manager.state.finished ? "was testing" : "will test"
      }  ${this.$parent.manager.minimax.depth} plays in the future. (${
        difficult[this.$parent.manager.minimax.depth]
      })`;
    },
  },
})
export default class Controls extends Vue {
  registration!: ServiceWorkerRegistration;

  refreshing = false;

  updateExists = false;

  controls = false;

  $parent!: Board;

  @Watch("finished")
  setControls() {
    this.controls = true;
  }

  resetCamera() {
    this.$parent.$parent.resetCamera();

    if (!this.$parent.manager.state.finished) this.close();
  }

  resetGame() {
    this.$parent.resetGame();

    this.close();
  }

  save() {
    this.close();
  }

  close() {
    this.$data.controls = !this.$data.controls;
  }

  private updateAvailable(event: CustomEvent) {
    this.registration = event.detail;
    this.updateExists = true;
  }

  private refreshApp() {
    this.updateExists = false;
    if (!this.registration || !this.registration.waiting) return;
    this.registration.waiting.postMessage({ type: "SKIP_WAITING" });
  }
}
